import React from 'react';
import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const metricsPlugin = createPlugin({
  id: 'metrics',
  routes: {
    root: rootRouteRef,
  },
});

/**
 * Landing page listing the available metrics dashboards.
 *
 * Exposed as a routable extension so the plugin owns the `metrics` route ref.
 */
export const MetricsPage = metricsPlugin.provide(
  createRoutableExtension({
    name: 'MetricsPage',
    component: () =>
      import('./components/MetricsPage').then(m => {
        const Component = m.MetricsPage;
        return (props: any) => {
          return React.createElement(Component, props);
        };
      }),
    mountPoint: rootRouteRef,
  }),
);
